/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { Select, SelectProps } from '@mantine/core'
import FormField from '../../../../client/js/components/form/fields/FormField'

export type InterventionTypeFieldProps = Omit<SelectProps, 'data'>

function InterventionTypeField (props: InterventionTypeFieldProps) {
  const { name = 'type', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'type',
        defaultMessage: 'Type'
      })}
      {...others}
      searchable
      name={name}
      render={Select}
      data={[
        {
          value: 'diy',
          label: intl.formatMessage({
            id: 'do_it_yourself',
            defaultMessage: 'Bricolage'
          })
        },
        {
          value: 'heating',
          label: intl.formatMessage({
            id: 'heating',
            defaultMessage: 'Chauffage'
          })
        },
        {
          value: 'air_conditioning',
          label: intl.formatMessage({
            id: 'air_conditioning',
            defaultMessage: 'Climatisation'
          })
        },
        {
          value: 'electricity',
          label: intl.formatMessage({
            id: 'electricity',
            defaultMessage: 'Électricité'
          })
        },
        {
          value: 'home_appliance',
          label: intl.formatMessage({
            id: 'home_appliance',
            defaultMessage: 'Électroménager'
          })
        },
        {
          value: 'outside',
          label: intl.formatMessage({
            id: 'outside',
            defaultMessage: 'Extérieur'
          })
        },
        {
          value: 'housework',
          label: intl.formatMessage({
            id: 'housework',
            defaultMessage: 'Ménage'
          })
        },
        {
          value: 'harmful',
          label: intl.formatMessage({
            id: 'harmful',
            defaultMessage: 'Nuisibles'
          })
        },
        {
          value: 'painting',
          label: intl.formatMessage({
            id: 'painting',
            defaultMessage: 'Peinture'
          })
        },
        {
          value: 'plumbing',
          label: intl.formatMessage({
            id: 'plumbing',
            defaultMessage: 'Plomberie'
          })
        },
        {
          value: 'locksmith',
          label: intl.formatMessage({
            id: 'locksmith',
            defaultMessage: 'Serrurerie'
          })
        },
        {
          value: 'other',
          label: intl.formatMessage({
            id: 'other',
            defaultMessage: 'Autre'
          })
        }
      ]}
    />
  )
}

export default InterventionTypeField
